// extracted by mini-css-extract-plugin
export default {"button":"TokenPurchaseButton_button__Rt56J","soldOutButton":"TokenPurchaseButton_soldOutButton__J2vc9"};